import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Modal, ModalBody, ModalHeader, Button } from 'reactstrap'
import { Form, Spinner } from 'react-bootstrap'
import { message } from 'antd'
import moment from 'moment'

import { updateAppointment } from '../services'
import { handleError } from '../../../helpers'

export default function CancelAppointmentModal({ visible, onClose, appointment, reload }) {
	const [loading, setLoading] = useState(false)
    const { handleSubmit, register, formState: { errors } } = useForm({
		defaultValues: {
			canceled_at: moment().format('YYYY-MM-DD HH:mm:ss')
		}
	})

	const onSubmit = values => {
		setLoading(true)
		updateAppointment(appointment.id, values)
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(error => handleError(error, setLoading))
	}

	return (
		<React.Fragment>
			<Modal isOpen={visible} toggle={onClose}>
				<ModalHeader toggle={onClose}>Cancelar Cita</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group className='form-group'>
							<Form.Label>Razón de la cancelación <span className='text-primary'>*</span></Form.Label>
                            <Form.Control 
                                as="textarea"    
                                {...register('canceled_comments', { required: true })}
                                placeholder='Escriba aquí...'
                                style={{ height: '150px' }}
                            />
                            { errors.canceled_comments && <Form.Text className='text-warning'>Este campo es requerido.</Form.Text> }
                        </Form.Group>
                        <Button color="primary" type="submit" disabled={loading}>
                            { loading && <Spinner animation='border' size="sm" className='mr-5' /> }
                            Cancelar Cita
                        </Button>
                    </Form>
                </ModalBody>
			</Modal>
		</React.Fragment>
	)
}